import { createContext, useContext } from "react";

import { CardFormLayoutHelper } from "./CardFormLayoutHelper.tsx";

export const CardFormLayoutContext = createContext<CardFormLayoutHelper>(
  {} as CardFormLayoutHelper
);

export const useCardFormLayoutContext = () => useContext(CardFormLayoutContext);
